<!--<app-notification-popup #popup></app-notification-popup>
<app-email-popup #EmailPopup></app-email-popup>-->
<header class="navbar">

  <div class="logo-container">
    <div class="hass-logo">
      <a a routerLink="/scheduler" routerLinkActive="active">
        <img src="/src/assets/images/HASSLogo.png" />
      </a>
    </div>
    <h2>where <strong>excellent hearing</strong> begins</h2>
  </div>

  <!--<nav>
    <ul class="nav-links">
      <li><a routerLink="scheduler" routerLinkActive="active">Calendar</a></li>
      <li><a routerLink="services" routerLinkActive="active">Services</a></li>
      <li><a routerLink="patients" routerLinkActive="active">Patients</a></li>
      <li><a routerLink="staff" routerLinkActive="active">Staff</a></li>
      <li><a routerLink="reports" routerLinkActive="active" style="border: none;">Reports</a></li>
    </ul>
  </nav>-->

  <nav>
    <ul class="nav-links" *ngIf="menuItems">
      <li *ngFor="let item of menuItems">
        <a [routerLink]="item.Url" routerLinkActive="active">
          {{ item.Name }}
        </a>
      </li>
    </ul>
  </nav>

  <div class="user-info">

    <div class="info-item">
      <i class="fas fa-bell" style=" margin-right: 15px;"></i>
      <i class="fas fa-calendar-alt"></i>
    </div>

    <div class="info-item">
      <p>{{staffMember.Name}}</p>
    </div>

    <div class="info-item" style="border: none; padding: 0px 0px 0 10px;">
      <p><a class="logout" (click)="Logout()">Logout</a></p>
    </div>

  </div>
  <button class="menu-toggle" (click)="SideMenuToggle()">=</button>
</header>
